import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { useT } from "../i18n";

export function LoginPage() {
  const { login } = useAuth();
  const { t } = useT();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-dark px-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center gap-2 mb-8">
          <span className="text-brand-red text-4xl leading-none">&#9656;</span>
          <span className="font-semibold text-3xl tracking-tight">HelixStream</span>
        </div>
        <form
          onSubmit={onSubmit}
          className="bg-brand-surface rounded-xl p-6 border border-brand-line"
        >
          <h1 className="text-xl font-semibold mb-5">{t("login.title")}</h1>
          <label className="block mb-4">
            <span className="text-sm text-brand-muted">{t("login.email")}</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full px-3 py-2 rounded bg-brand-dark border border-brand-line focus:border-brand-red outline-none"
              required
            />
          </label>
          <label className="block mb-4">
            <span className="text-sm text-brand-muted">{t("login.password")}</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full px-3 py-2 rounded bg-brand-dark border border-brand-line focus:border-brand-red outline-none"
              required
            />
          </label>
          {error && (
            <p className="text-sm text-red-400 mb-3">{error}</p>
          )}
          <button
            type="submit"
            disabled={busy}
            className="w-full py-2 rounded bg-brand-red hover:bg-red-700 disabled:opacity-50 font-medium"
          >
            {busy ? t("login.signingIn") : t("login.submit")}
          </button>
          <p className="text-xs text-brand-muted mt-4 text-center">
            {t("login.hint")}
          </p>
        </form>
      </div>
    </div>
  );
}